module.exports = __webpack_public_path__ + "img/home-educacao.e9ee1186.svg";